// extracted by mini-css-extract-plugin
export default {"switch":"ThemeSwitcher_switch__3EzrZ"};